<template lang="html">
  <div class="help">
    <headline :params="headLines"></headline>
    <div class="container">
      <div class="tabs">
        <div class="cate" v-for="(c, d) in tabs" :key="d">
          <div class="title" @click="toggleTab(c)">
            <span>{{c.title}}</span>
            <img :src="c.expand ? icons.up : icons.down" alt="icon">
          </div>
          <div v-show="c.expand" :class="{question: true, on: selectedItem.id === q.id}" v-for="(q, i) in c.children" :key="i" @click.stop="selectItem(q)">
            {{q.title}}
          </div>
        </div>
      </div>
      <div class="content">
        <div class="title">
          {{title|| '标题'}}
        </div>
        <div class="detail" v-html="content || '内容'"></div>
      </div>
    </div>
  </div>
</template>
<script>
import headline from '@components/headline'
import common from '@common/common'
import {apis} from '@common/config'

export default {
  name: 'help',
  components: {
    headline
  },
  data() {
    return {
      isXnew: true,
      headLines: {
        title: '帮助中心',
        showLink: false,
        filter: false
      },
      tabs: [],
      content: '',
      title: '',
      selectedItem: {},
      icons: {
        up: require('@assets/img/common/upward.svg'),
        down: require('@assets/img/common/xiala.svg')
      }
    }
  },
  methods: {
    selectItem(i) {
      this.selectedItem = i
      this.getContent(i.id)
    },
    toggleTab(t) {
      if (t.expand) {
        this.$set(t, 'expand', false)
        return
      }

      this.tabs.forEach(i => {
        if (i.expand) {
          this.$set(i, 'expand', false)
        }
      })

      this.$nextTick(() => {
        this.$set(t, 'expand', true)
      })
    },
    getMenu() {
      return common.myFetch(apis.help_menu, {})
      .then(r => {
        if (r) {
          return r
        }
      })
    },
    getContent(id) {
      const info = {
        id: id
      }

      common.myFetch(apis.help_detail, info)
      .then(r => {
        if (r) {
          this.title = r.title
          this.content = r.content
        }
      })
    },
    async init() {
      const tabs = await this.getMenu()
      this.tabs = tabs

      const firstTab = this.tabs[0]
      const firstItem = firstTab.children[0] || {}
      this.toggleTab(firstTab)
      this.selectItem(firstItem)
    }
  },
  mounted() {
    this.init()
  },
  created() {
    let domin = window.document.domain;
    let isXnew = true;
    if(domin.indexOf('xnews')!=-1){
      isXnew = true
    }else if(domin.indexOf('localhost')!=-1){
      isXnew = true
    }else{
      isXnew = false
    }
    this.isXnew = isXnew;
  }
}
</script>

<style lang="less" scoped>
  @import '../assets/css/global.less';

  .help {
    padding: 100px 20px 50px;
    // height: 100%;
    .wrapper {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
    }
    .container {
      display: flex;
      height: 100%;
      .tabs {
        width: 210px;
        margin-right: 20px;
        height: auto;
        position: fixed;
        .boxOuter;
        overflow-y: auto;
        max-height: calc(100vh - 150px);
        &::-webkit-scrollbar {
            width: 0;
            height: 0;
        }
        .cate {
          font-size: 16px;
          .title {
            height: 50px;
            display: flex;
            align-items: center;
            padding: 0 20px 0 0;
            cursor: pointer;
            span {
              padding-left: 30px;
              flex: 1;
            }
          }
          .question {
            // height: 50px;
            line-height: 50px;
            padding-left: 26px;
            border-left: 4px solid transparent;
            color: @sub;
            cursor: pointer;
          }
          .on {
            border-color: @green;
            color: @green;
            background-color: @grnBg;
          }
        }
      }
      .content {
        flex: 1;
        min-height: calc(100vh - 150px);
        margin-left: 230px;
        min-width: 834px;
        padding: 20px 30px;
        .boxOuter;
        .title {
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 20px;
        }
        .detail {
          text-align: justify;
        }
        .detail/deep/p span{
          font-size: 16px !important;
          line-height: 30px !important;
        }
      }
    }
  }
</style>
